<template>
  <div class="recordContentWrap bgcScN2">
    <div class="recordContent">
      <div class="emptyBox colAc" v-if="recordData.length == 0">
        <img src="../../assets/static/emptyList.png" alt="未产生办理记录" />
        <div>暂时还没有办理记录</div>
      </div>
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        finished-text="没有更多记录了"
        @load="onLoad"
      >
        <van-cell v-for="(record, id) in recordData" :key="id">
          <div class="recordItem">
            <div class="recordItemId rowJb">
              <div class="serialNumber fontH3 fontScN7">
                业务流水号：{{ record.id }}
              </div>
              <div class="recordStatus fontH3 fontScN7">
                <span v-if="record.status === 0">未支付</span>
                <span v-if="record.status === 1">已支付</span>
              </div>
            </div>
            <div class="recordDetails bgcScN1">
              <div class="recordType fontH2 fontScN8">
                业务类型：<span v-if="record.type === 1">报名</span>
                <span v-if="record.type === 2">退费</span>
                <span v-if="record.type === 3">转课</span>
                <span v-if="record.type === 4">充值</span>
                <span v-if="record.type === 5">补缴</span>
                <span v-if="record.type === 8">物品</span>
                <span v-if="record.type === 9">结课退费</span>
                <span v-if="record.type === 12">考级报名</span>

              </div>
              <div class="accepterName fontH3 fontScN7">
                购买学员：{{ record.accepterName }}
              </div>
              <div class="businessContent fontH3 fontScN7 lineFeed">
                业务内容：{{ record.businessInfo }}
              </div>
              <div class="agentPeople fontH3 fontScN7">
                经办人：{{ record.createUserName }}
              </div>
              <div class="agentDate fontH3 fontScN7">
                经办日期：{{ record.dealDate }}
              </div>
            </div>
            <div class="paymentDetails">
              <div class="totalPrice fontH3 fontScN8 right">
                总价：<span class="fontMcA1"
                  >￥{{ Number(record.receivableAmount).toFixed(2) }}</span
                >
              </div>
              <div class="actualPayment fontH2 fontScN8 right">
                实付款：<span class="fontMcA1"
                  >￥{{ Number(record.paidInAmount).toFixed(2) }}</span
                >
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getRecordListAPI } from "../../utils/api/api";
export default {
  data() {
    return {
      campusItem: {},
      currPage: 1,
      pageSize: 10,
      params: {},
      campusCode: "",
      customerId: "",
      loading: false,
      finished: false,
      nowPageLength: 0,
      total: 0,
      recordData: [],
    };
  },
  created() {
    
    if (this.$common.getCache("campusItem")) {
        this.campusItem = JSON.parse(this.$common.getCache("campusItem"));
        console.log("this.campusItem", this.campusItem);
        this.campusCode = this.campusItem.campusCode
        this.customerId = this.campusItem.customerId
    } else {
      var campusList = JSON.parse(this.$common.getCache("customerAuthList"));
      console.log("this.campusList", campusList);
      campusList.forEach((item, index) => {
        if (index == 0) {
          this.campusCode = item.campusCode;
          this.customerId = item.customerId;
        }
      });
    }
    this.getRecordList()
  },
  methods: {
    onLoad() {
        //console.log('nowPageLength', this.nowPageLength)
        console.log('total', this.total)
            if(!this.finished) {
                setTimeout(() => {
                    this.currPage++
                    this.getRecordList()
                    this.nowPageLength = this.recordData.length
                },500)
                this.loading = false
            }
    
    },
    getRecordList() {
        var params = {
            campusCode: this.campusCode,
            customerId: this.customerId,
            currPage: this.currPage,
            pageSize: this.pageSize
        }
        getRecordListAPI(params).then((res) => {
        if (res.resultCode == 200) {
            console.log(res)
            this.recordData = this.recordData.concat(res.data.dataList);
            this.total = res.data.totalCount
            //this.loading = false
            this.nowPageLength = this.recordData.length
            if(this.nowPageLength == this.total) {
                this.finished = true
            }
            console.log('nowPageLength', this.nowPageLength)
         }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.recordContentWrap {
  height: 100%;
  overflow: auto;
  .recordContent {
    .recordItem {
      background-color: #fff;
      padding: 12px 16px;
      margin-top: 12px;
    }
    .recordDetails {
      margin-top: 10px;
      padding: 12px 16px;
      .accepterName {
        padding-top: 8px;
      }
    }
    .paymentDetails {
      padding-top: 12px;
    }
    .emptyBox {
      img {
        width: 165px;
        height: 114px;
        margin-top: 40px;
      }
      > div {
        font-size: 13px;
        color: #9ea8ba;
        line-height: 19px;
      }
    }
  }
}
</style>